import { Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { SnackBarComponent } from '@pages/snackbar.component';
import { Observable, of, timer } from 'rxjs';
import { catchError, retry, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpUtilsService 
{
  HTTP_CLIENT_TIMEOUT:number = 1000 * 6
  HTTP_CLIENT_RETRY_TIMER:number = 2000
  HTTP_CLIENT_COUNT:number = 2

  constructor(private bottomSheet: MatBottomSheet) {}

  applyHttpRetryAndTimeout<T>() 
  {
    return (source$: Observable<T>): Observable<T | never[]> => {
      return source$.pipe(
        timeout(this.HTTP_CLIENT_TIMEOUT),

        retry({
          count: this.HTTP_CLIENT_COUNT,
          delay: (_error, retryIndex) => {
            console.log("retry : " + retryIndex)
            return timer(this.HTTP_CLIENT_RETRY_TIMER)
          }
        }),

        catchError(_err => {
          const sheetRef = this.bottomSheet.open(SnackBarComponent, { disableClose: true })

          sheetRef.afterDismissed().subscribe((res) => {
            if (res?.message === "reload") window.location.reload()
          })

          return of([])
        })
      )
    }
  }
}
